/**
 * @file paddle hub 菜单的 hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useCallback, useMemo, useState} from 'react';
import isNil from 'lodash/isNil';

import {IPaddleHubMenu, IPaddleHubMenuName, IPaddleHubMenuSearch} from './type.d';
import {
    DEFAULT_PADDLE_MENU_FILTER,
    PADDLE_HUB_MENU_TOP, PADDLE_MENU_HOT
} from './constants';
import {fetchGetMenuList} from '../../api/pages/paddleHubApi';
import getSortParams from '../../utils/get-sort-params';


// 获取menu必要的url参数
export const getSelectedMenuKey = (init?: string[][] | Record<string, string> | string | URLSearchParams) => {
    const urlSearch = new URLSearchParams(init);
    const resSearch = new URLSearchParams();

    const setParam = (params: URLSearchParams, key: string, value?: string | null) => {
        !isNil(value) ? params.set(key, value) : params.delete(key);
    };

    setParam(resSearch, 'filter', urlSearch.get('filter') || PADDLE_MENU_HOT.search.filter);
    setParam(resSearch, 'value', urlSearch.get('value') || PADDLE_MENU_HOT.search.value);
    setParam(resSearch, 'exclude', urlSearch.get('exclude') || PADDLE_MENU_HOT.search.exclude);
    resSearch.sort();
    return resSearch.toString();
};


// 预请求
let preRequest: any = {
    fetchGetMenuList: fetchGetMenuList()
};

/**
 * @param selectedValue 选中元素的
 * @author FengGuang(fengguang01@baidu.com)
 */
export function useMenuList(initMenuSelectedKeys?: string[] | (() => string[])) {
    const [menuList, setMenuList] = useState<IPaddleHubMenu[]>([]);
    const [menuSelectedKeys, setMenuSelectedKeys] = useState<string[]>(() => {
        if (!initMenuSelectedKeys) {
            return [];
        }
        if (typeof (initMenuSelectedKeys) === 'function') {
            return [getSelectedMenuKey(initMenuSelectedKeys().slice(-1)[0])];
        }
        return [getSelectedMenuKey(initMenuSelectedKeys.slice(-1)[0])];
    });

    const getMenuList = useCallback(async () => {
        const fetchFunc = preRequest.fetchGetMenuList || fetchGetMenuList();
        delete preRequest.fetchGetMenuList;

        const res = await fetchFunc.catch();
        if (res) {
            const list: any[] = res.body.result.data || [];

            const transMenu = (oldMenu: any[] = []): IPaddleHubMenu[] => {
                return oldMenu.map(item => {
                    const name: IPaddleHubMenuName = {
                        en: item.name.en,
                        chn: item.name.chn
                    };
                    const search: IPaddleHubMenuSearch = {
                        filter: DEFAULT_PADDLE_MENU_FILTER,
                        value: item.name.en
                    };
                    return {
                        key: getSortParams({...search}),
                        search,
                        name,
                        chs: item.chs ? transMenu(item.chs) : []
                    };
                });
            };

            const newList = transMenu(list);
            setMenuList(newList);
            return newList;
        }
    }, []);

    const menuListWithTop = useMemo(() => {
        return [...PADDLE_HUB_MENU_TOP, ...menuList];
    }, [menuList]);

    return {
        menuList: menuListWithTop,
        menuSelectedKeys,
        setMenuSelectedKeys,

        getMenuList
    };
}
